import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteABanner,
  getBanners,
  resetState,
} from "../features/banner/bannerSlice";
import CustomModal from "../components/CustomModal";
import { resolveMediaUrl } from "../utils/mediaUrl";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "title",
    sorter: (a, b) => a.title.length - b.title.length,
  },
  {
    title: "Image",
    dataIndex: "image",
    render: (text) => (
      <img
        src={resolveMediaUrl(text)}
        alt=""
        width={50}
        height={50}
        style={{ objectFit: "cover" }}
      />
    ),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Bannerlist = () => {
  const [open, setOpen] = useState(false);
  const [bannerId, setbannerId] = useState("");
  const [loading, setLoading] = useState(true);

  const showModal = (e) => {
    setOpen(true);
    setbannerId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(resetState());
  //   dispatch(getBanners());
  // }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(resetState());
      await dispatch(getBanners());
      setLoading(false);
    };

    fetchData();
  }, [dispatch]);

  const bannerStat = useSelector((state) => state.banner.banners);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // const data1 = [];
  // for (let i = 0; i < bannerStat.length; i++) {
  //   data1.push({
  //     key: i + 1,
  //     title: bannerStat[i].banner_title,
  //     image: bannerStat[i].banner_image,
  //     action: (
  const data1 = bannerStat.map((banner, index) => ({
    key: index + 1,
    title: banner.banner_title,
    image: banner.banner_image,
    action: (
      <>
        <Link
          to={`/admin/banner/${banner._id}`}
          className=" fs-3 text-danger"
        >
          <BiEdit />
        </Link>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(banner._id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  const deletBanner = (e) => {
    dispatch(deleteABanner(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getBanners());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Banners List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deletBanner(bannerId);
        }}
        title="Are you sure you want to delete this banner?"
      />
    </div>
  );
};

export default Bannerlist;
